export enum StockedSignalingsActionEnum {
    created = 'CREATED',
    edited = 'EDITED',
    removed = 'REMOVED',
    edited_removed = 'EDITED_REMOVED',
    maintenance = 'MAINTENANCE',
    replacement = 'REPLACEMENT',
    retroreflection = 'RETROREFLECTION',
    end_of_warranty = 'END_OF_WARRANTY',
    expired_warranty = 'EXPIRED_WARRANTY',
    addition = 'ADDITION',
    refund = 'REFUND',
  };